document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.hk-mobile-menu');
  const open = document.querySelector('.hk-menu-button');
  const close = document.querySelector('.hk-mobile-close');
  const scrim = document.querySelector('.hk-scrim');
  if (!menu || !open || !close || !scrim) return;
  const setOpen = (value) => {
    menu.classList.toggle('is-open', value);
    scrim.classList.toggle('is-open', value);
    menu.setAttribute('aria-hidden', String(!value));
    menu.toggleAttribute('inert', !value);
    open.setAttribute('aria-expanded', String(value));
    document.documentElement.style.overflow = value ? 'hidden' : '';
  };
  open.addEventListener('click', () => setOpen(true));
  close.addEventListener('click', () => setOpen(false));
  scrim.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hk-product-card__media').forEach((media) => {
    const image = media.querySelector('[data-hover-image]');
    if (!image) return;

    const loadHoverImage = () => {
      if (image.src) return;
      image.srcset = image.dataset.hoverSrcset || '';
      image.src = image.dataset.hoverSrc || '';
    };

    media.addEventListener('pointerenter', loadHoverImage, { once: true });
    media.addEventListener('focusin', loadHoverImage, { once: true });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-deferred-image]').forEach((image) => {
    const loadImage = () => {
      if (image.src || !image.dataset.src) return;
      image.src = image.dataset.src;
    };

    if (!('IntersectionObserver' in window)) {
      loadImage();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      loadImage();
      observer.disconnect();
    }, { rootMargin: '800px 0px' });

    observer.observe(image);
  });
});
